module.exports = __webpack_public_path__ + "static/img/banner_06.24e5691e.png";